import React from 'react'
import { Box, SxProps } from '@mui/material'
import { EmtTypography, EmtIcon } from 'emt-components-v2'

interface InfoBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string
  text?: string
  iconClass?: string
  icon?: React.ReactNode
  center?: boolean
  sx?: SxProps
}

export const InfoBox: React.FC<InfoBoxProps> = ({ title, text, icon, iconClass, center, sx }) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: center ? 'column' : 'row',
        textAlign: center ? 'center' : 'left',
        alignItems: 'center',
        gap: center ? '10px' : '13px',
        padding: '15px',
        backgroundColor: '#fff',
        borderRadius: '16px',
        border: '1px solid #E8E8EA',
        ...sx,
      }}
    >
      {icon && icon}
      {iconClass && <EmtIcon className={iconClass} sx={{ color: '#AE59C6', fontSize: '23px' }} />}
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
        <EmtTypography fontSize="16px" variant="body2" fontWeight="700" color="#AE59C6">
          {title}
        </EmtTypography>
        {text && (
          <EmtTypography variant="body2" fontWeight="600" color="#1D1929">
            {text}
          </EmtTypography>
        )}
      </Box>
    </Box>
  )
}
